import { PropsWithChildren } from "react"
import Text from "../../../../../components/Text"
import { styled, theme } from "../../../../../styles/stitches.config"

const SWrapper = styled("h2", {
  margin: 0,
  textAlign: "center",
})

type Props = {
  asSectionHeader?: boolean
}

export function Subheader(props: PropsWithChildren<Props>) {
  const { children, asSectionHeader } = props

  const subheader = (
    <Text
      type="headerH2"
      css={{
        fontSize: theme.sizes.s5,
        lineHeight: "19px",
      }}
    >
      {children}
    </Text>
  )

  return asSectionHeader ? <SWrapper>{subheader}</SWrapper> : subheader
}
